import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from "react-notifications";
import { Provider } from 'react-redux';
import store from './reduxSetup/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store = {store}>
      <NotificationContainer/>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
